import styled, { css } from '../../../../styled';
export const Column = styled.div `
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
`;
export const ColumnButton = styled(Column) `
  color: ${({ theme, isDefault }) => isDefault ? theme.colors.PRIMARY_600 : theme.colors.INK_800};
  font-weight: ${({ isDefault }) => (isDefault ? 600 : 'inherit')};
  cursor: pointer;
  border-radius: 0;

  :hover {
    background-color: ${({ theme }) => theme.colors.PRIMARY_200};
  }

  ${({ isSelected, isFromSelected, isToSelected, isPeriod }) => !isSelected &&
    !isFromSelected &&
    !isToSelected &&
    !isPeriod &&
    css `
      :hover {
        border-radius: 6px;
      }
    `};

  ${({ isSelected, isFromSelected, isToSelected }) => (isSelected || isFromSelected || isToSelected) &&
    css `
      background-color: ${({ theme }) => theme.colors.PRIMARY_600};
      color: ${({ theme }) => theme.colors.SNOW_100};

      :hover {
        background-color: ${({ theme }) => theme.colors.PRIMARY_600};
      }
    `};

  ${({ isFromSelected }) => isFromSelected &&
    css `
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    `};

  ${({ isToSelected }) => isToSelected &&
    css `
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    `};

  ${({ isPeriod, isSelected, isFromSelected, isToSelected }) => isPeriod &&
    !(isSelected || isFromSelected || isToSelected) &&
    css `
      background-color: ${({ theme }) => theme.colors.PRIMARY_200};

      :hover {
        background-color: ${({ theme }) => theme.colors.PRIMARY_400};
      }
    `};

  ${({ isDisabled }) => isDisabled &&
    css `
      background-color: ${({ theme }) => theme.colors.SNOW_100};
      color: ${({ theme }) => theme.colors.INK_400};
      cursor: default;
      border-radius: 6px;

      :hover {
        background-color: ${({ theme }) => theme.colors.SNOW_100};
      }
    `};
`;
//# sourceMappingURL=Column.js.map